import React, { useRef } from 'react'
import Button from '../../components/Button'
import styles from './styles.module.scss'
import { useState } from 'react'
import { useFormik } from 'formik'
import Modal from './modal'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import useDoubleClick from 'use-double-click'
import classNames from 'classnames'
import { Checkbox, Input } from '../../components/ModalInputs'
import CustomSelect from '../../components/CustomSelect'
import { arrayForSelect } from '../../utils/arrayForSelect'
import { getEventById, getEventsList, getEventClasses } from '../../actions/events_list'
import {
  getLibraryEducDirections,
  getLibraryNewsLevels,
  getLibraryEventTypes,
  getLibraryEventForms,
  getLibraryParallels,
  getLibraryTeachers,
} from '../../actions/library'

export default function EventsList() {

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { eventsList, eventInfo, eventClasses } = useSelector(state => state.events_list)

  const {
    educDirections,
    newsLevels,
    eventTypes,
    eventForms,
    parallels,
    teachers,
  } = useSelector(state => state.library)

  const [event, setEvent] = useState(null)
  const [selectedId, setSelectedId] = useState(null)

  const openModal = (data) => () => {
    setEvent(data)
  }


  const closeModal = () => setEvent(null)

  const goHome = () => navigate('/')

  const onSubmit = (values) => {
    dispatch(getEventsList(values))
  }

  const today = new Date()
  const prevMonth = new Date(today)
  prevMonth.setMonth(prevMonth.getMonth() - 1)
  const prevMonthStr = prevMonth.toISOString().slice(0, 10)
  const nextMonth = new Date(today)
  nextMonth.setMonth(nextMonth.getMonth() + 1)
  const nextMonthStr = nextMonth.toISOString().slice(0, 10)

  const {
    values,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues: {
      date_from: prevMonthStr,
      date_to: nextMonthStr,
      parallel: 0,
      class_gid: 0,
      teacher_mid: 0,
      news_level_id: 0,
      ev_type_id: 0,
      acid: 0,
      edid: 0,
    },
    onSubmit
  })

  useEffect(() => {
    dispatch(getLibraryEducDirections())
    dispatch(getLibraryNewsLevels())
    dispatch(getLibraryEventTypes())
    dispatch(getLibraryEventForms())
    dispatch(getLibraryTeachers())
  }, [])

  const isValidDate = (dateString) => {
    if (!dateString || dateString.length !== 10) return false
    const date = new Date(dateString)
    if (!(date instanceof Date) || isNaN(date)) return false
    const year = date.getFullYear()
    return year >= 1900 && year <= 2100
  }

  useEffect(() => {
    if (isValidDate(values.date_from)) {
      dispatch(getLibraryParallels(values.date_from))
      dispatch(getEventClasses(values.date_from, values.parallel))
    }
  }, [values.date_from, values.parallel])

  useEffect(() => {
    values.date_from && values.date_to && !eventClasses && dispatch(getEventsList(values))
  }, [eventClasses])

  useEffect(() => {
    eventsList && !eventClasses && dispatch(getEventsList(values))
  }, [eventsList])

  useEffect(() => {
    event?.nid && dispatch(getEventById(event?.nid))
  }, [event])

  return (
    <div className={styles.wrapper}>
      <Modal
        event={event?.nid ? eventInfo : null}
        isOpen={!!event}
        closeModal={closeModal}
        filters={values}
      />

      <h1>Список мероприятий</h1>
      <div className={styles.filters}>
        <div className={styles.filtersBlock}>

          <Input
            type='date'
            label='Период действия с'
            name='date_from'
            value={values.date_from}
            onChange={handleChange}
          />
          <Input
            type='date'
            label='Период действия по'
            name='date_to'
            value={values.date_to}
            onChange={handleChange}
          />

          <CustomSelect
            title='Параллель'
            valuesName="parallel"
            value={values.parallel}
            options={parallels && arrayForSelect(parallels, 'year', 'year')}
            setFieldValue={setFieldValue}
          />
          <CustomSelect
            title='Взвод'
            valuesName="class_gid"
            value={values.class_gid}
            options={eventClasses && arrayForSelect(eventClasses, 'name', 'gid')}
            setFieldValue={setFieldValue}
          />
          <CustomSelect
            title='Ответственный'
            valuesName="teacher_mid"
            value={values.teacher_mid}
            options={teachers && arrayForSelect(teachers, 'employer', 'mid')}
            setFieldValue={setFieldValue}
          />
          <CustomSelect
            title='Уровень мероприятия'
            valuesName="news_level_id"
            value={values.news_level_id}
            options={newsLevels && arrayForSelect(newsLevels, 'news_level', 'news_level_id')}
            setFieldValue={setFieldValue}
          />

          <div className={styles.filtersBlock}>
            <CustomSelect

              title='Форма мероприятия'
              valuesName="acid"
              value={values.acid}
              options={eventForms && arrayForSelect(eventForms, 'name', 'acid')}
              setFieldValue={setFieldValue}
            />
          
          <div className={styles.checkbox} style={{ display: 'flex', alignItems: 'end', marginBottom: '.7rem' }}>
            <Checkbox
              label='Мои мероприятия'
              name='own_events'
              checked={values.own_events}
              onChange={() => setFieldValue('own_events', !values.own_events)}
            />
          </div>
        </div>

          <CustomSelect
            title='Тип события'
            valuesName="ev_type_id"
            value={values.ev_type_id}
            options={eventTypes && arrayForSelect(eventTypes, 'ev_type', 'ev_type_id')}
            setFieldValue={setFieldValue}
          />

          <CustomSelect
            title='Направление воспитательной работы'
            valuesName="edid"
            value={values.edid}
            options={educDirections && arrayForSelect(educDirections, 'name', 'edid')}
            setFieldValue={setFieldValue}
            width={270}
          />
          <Input
            label='Поиск по названию'
            name='name_filter'
            maxLength={25}
            value={values.name_filter}
            onChange={handleChange}
            style={{ width: '400px', display: 'flex' }}
            labelStyle={{ marginBottom: '0.7rem' }}
          />
          <div className={styles.checkbox} 
            style={{ display: 'flex', alignItems: 'end', "paddingBottom": ".7rem" }}>

            <Checkbox
              label='Входит в план ГУК МО РФ'
              name='included_in_md_plan'
              checked={values.included_in_md_plan}
              onChange={() => setFieldValue('included_in_md_plan', !values.included_in_md_plan)}
            />
          </div>

          <Button 
          style={{ "marginTop": "1.5rem" }}
          onClick={handleSubmit} disabled={!values.date_from || !values.date_to}>Обновить</Button>

        </div>
        
      </div>
      
      <Button 
        onClick={openModal({})} 
        disabled={!values.date_from} 
        style={{ marginBottom: '2.5rem' }}>Добавить</Button>

      {eventsList && eventsList.map(ev =>
        <EventItem
          key={ev.nid}
          data={ev}
          selected={selectedId === ev.nid}
          onSelect={() => setSelectedId(ev.nid)}
          onOpen={openModal(ev)}
        />
      )}
      <footer className={styles.footer}>
        <div></div>
        <Button mode='white' onClick={goHome}>Закрыть</Button>
      </footer>
    </div >
  )
}


const EventItem = ({ data, selected, onSelect, onOpen }) => {
  const rowRef = useRef()

  useDoubleClick({
    onSingleClick: onSelect,
    onDoubleClick: onOpen,
    ref: rowRef,
    latency: 250
  })

  return (
    <div
      ref={rowRef}
      className={classNames(styles.eventList, { [styles.selectedRow]: selected })}
      style={{ cursor: 'pointer' }}
    >
      <div className={styles.eventHeader}>
        {data.event_date}, {data.title}
      </div>
      <div><span className={styles.eventLabel}>Место проведения:</span> {data.author || ''}</div>
      <div><span className={styles.eventLabel}>Участвуют:</span> {data.spisok || ''}</div>
      <div><span className={styles.eventLabel}>Ответственные:</span> {data.comm_new || ''}</div>
    </div>
  )
}